import { render, staticRenderFns } from "./IRadio.vue?vue&type=template&id=0d42cf5d&"
import script from "./IRadio.vue?vue&type=script&lang=ts&"
export * from "./IRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports